import Entity from '../entity'

export default class Coupon extends Entity<number>{
 name:string="";
 sex:number=0;
 userId:boolean=false;
 mobile:string="";
 cardType:string="";
}
